import { render, staticRenderFns } from "./businessAnalysis-list-business.vue?vue&type=template&id=67ddffd4&scoped=true&"
import script from "./businessAnalysis-list-business.vue?vue&type=script&lang=js&"
export * from "./businessAnalysis-list-business.vue?vue&type=script&lang=js&"
import style0 from "./businessAnalysis-list-business.vue?vue&type=style&index=0&id=67ddffd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddffd4",
  null
  
)

export default component.exports